export default __webpack_public_path__ + "static/media/screen4.908c5b60.png";